const Thermometer = {
  mounted() {
    let detailsDiv = this.el.querySelector("[js-id=goalDetails]");
    let goalDetailsToggle = this.el.querySelector("[js-id=goalDetailsToggle]");
    setTimeout(() => detailsDiv.style.opacity = 1, 100 )
    setTimeout(() => detailsDiv.style.opacity = 0, 5000 )
    goalDetailsToggle.addEventListener("click", function() {
      let detailsDiv = document.querySelector("[js-id=goalDetails]");
      detailsDiv.style.opacity = 1 - parseInt(detailsDiv.style.opacity || 0)
    })
  },
}

export default { Thermometer }
